<div class="layout-dashboard">
    <div class="grid">
        <div class="col-12 xl:col-12">
            <div class="card">
                <div class="report-inner w-full">
                    <h4>{{ "REPORTS" | translate }}</h4>
                    <p-tabView
                        headerStyleClass="left-aligned-tabs"
                        class="w-full"
                    >
                        <p-tabPanel
                            class="w-full"
                            [header]="'SALES_REPORT' | translate"
                        >
                            <div
                                [formGroup]="reportForm"
                                class="p-fluid p-form-grid grid"
                            >
                                <div class="field col-12 md:col-2 mb-0">
                                    <label
                                        htmlFor="dob"
                                        class="text-sm text-500"
                                        >{{
                                            "REPORT_FROM_DATE" | translate
                                        }}</label
                                    >
                                    <p-calendar
                                        #dob
                                        [placeholder]="'START_DATE' | translate"
                                        formControlName="startDate"
                                    >
                                    </p-calendar>
                                </div>
                                <div class="field col-12 md:col-2 mb-0">
                                    <label
                                        htmlFor="dob"
                                        class="text-sm text-500"
                                        >{{
                                            "REPORT_TO_DATE" | translate
                                        }}</label
                                    >
                                    <p-calendar
                                        #dob
                                        [placeholder]="'END_DATE' | translate"
                                        formControlName="endDate"
                                    >
                                    </p-calendar>
                                </div>
                                <div class="field col-12 md:col-2 mb-0">
                                    <label
                                        htmlFor="gender"
                                        class="text-sm text-500"
                                        >{{
                                            "CUSTOMER_TYPE" | translate
                                        }}</label
                                    >
                                    <p-dropdown
                                        formControlName="customerType"
                                        [options]="displayedCustomerTypes"
                                        optionLabel="value"
                                        optionValue="name"
                                        [placeholder]="
                                            'CUSTOMER_TYPE' | translate
                                        "
                                    >
                                    </p-dropdown>
                                </div>
                                <div class="field col-12 md:col-2 mb-0">
                                    <label
                                        htmlFor="gender"
                                        class="text-sm text-500"
                                        >{{ "ORDER_STATUS" | translate }}</label
                                    >
                                    <p-dropdown
                                        formControlName="orderStatus"
                                        [options]="displayedOrderStatuses"
                                        optionLabel="value"
                                        optionValue="name"
                                        [placeholder]="
                                            'SELECT_STATUS' | translate
                                        "
                                    >
                                    </p-dropdown>
                                </div>
                                <div class="field col-12 md:col-2 mb-0">
                                    <label
                                        htmlFor="gender"
                                        class="text-sm text-500"
                                    ></label>
                                    <div
                                        class="flex align-items-end justify-content-start gap-2 mt-2"
                                    >
                                        <p-button
                                            icon="pi pi-search"
                                            pRipple
                                            [disabled]="!reportForm.valid"
                                            [label]="'SEARCH' | translate"
                                            severity="primary"
                                            (onClick)="searchClicked()"
                                        />
                                        <p-button
                                            icon="pi pi-download"
                                            pRipple
                                            [disabled]="reportItems.length == 0"
                                            [label]="'DOWNLOAD' | translate"
                                            severity="warning"
                                            (onClick)="downloadClicked()"
                                        />
                                    </div>
                                </div>
                                <div></div>
                            </div>
                            <div class="mt-4">
                                <p-divider></p-divider>
                            </div>
                            <div class="table-container w-full mt-2">
                                <p-table
                                    [paginator]="true"
                                    #salesReportsPage
                                    id="salesReportsPage"
                                    [rows]="5"
                                    [value]="reportItems"
                                    responsiveLayout="scroll"
                                    styleClass="p-datatable-striped p-datatable-table"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>
                                                {{ "ORDER_DATE" | translate }}
                                            </th>
                                            <th>
                                                {{
                                                    "CUSTOMER_NAME" | translate
                                                }}
                                            </th>
                                            <th>{{ "VRN" | translate }}</th>
                                            <th>
                                                {{
                                                    "VEHICLE_MODEL" | translate
                                                }}
                                            </th>
                                            <th>
                                                {{
                                                    "VEHICLE_USAGE" | translate
                                                }}
                                            </th>
                                            <th>
                                                {{
                                                    "CARRYING_CAPACITY"
                                                        | translate
                                                }}
                                            </th>
                                            <th>
                                                {{
                                                    "VEHICLE_VALUE" | translate
                                                }}
                                                (MZN)
                                            </th>
                                            <th>{{ "INSURER" | translate }}</th>
                                            <th>
                                                {{
                                                    "INSURANCE_TYPE" | translate
                                                }}
                                            </th>
                                            <th>
                                                {{
                                                    "COVER_START_DATE"
                                                        | translate
                                                }}
                                            </th>
                                            <th>
                                                {{
                                                    "NEXT_RENEWAL_DATE"
                                                        | translate
                                                }}
                                            </th>
                                            <th>
                                                {{ "AMOUNT" | translate }} (MZN)
                                            </th>
                                            <th>
                                                {{
                                                    "PAYMENT_METHOD" | translate
                                                }}
                                            </th>
                                            <th>{{ "STATUS" | translate }}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-item>
                                        <tr>
                                            <td>
                                                {{
                                                    item.orderDate != null
                                                        ? (item.orderDate
                                                          | date)
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.customerName != null
                                                        ? item.customerName
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.vrn ? item.vrn : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.vehicleModel
                                                        ? item.vehicleModel
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.vehicleUse
                                                        ? (item.vehicleUse | translate)
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.carryingCapacity
                                                        ? item.carryingCapacity
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.vehicleValue
                                                        ? (item.vehicleValue
                                                          | number : "1.2-2")
                                                        : "---"
                                                }}
                                            </td>

                                            <td>
                                                {{
                                                    item.insurer
                                                        ? item.insurer
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.insuranceType
                                                        ? (item.insuranceType | translate)
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.coverStartDate
                                                        ? (item.coverStartDate
                                                          | date)
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.nextRenewalDate
                                                        ? (item.nextRenewalDate
                                                          | date)
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.amount
                                                        ? (item.amount
                                                          | number : "1.2-2")
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.paymentMethod
                                                        ? item.paymentMethod
                                                        : "---"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    item.status
                                                        ? (item.status | translate)
                                                        : "---"
                                                }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
        </div>
    </div>
</div>
